import React from 'react';
import classNames from 'classnames';

const ns = `numeric-input`;

const NumericInput = ({
	onIncrement,
	onDecrement,
	className,
	disabled,
	decrementLabel = 'Decrease quantity',
	incrementLabel = 'Increase quantity',
	...props
}) => {
	const rootClassnames = classNames({
		[`${ ns }`]: true,
	});

	return (
		<div className={rootClassnames}>
			<button
				type="button"
				disabled={disabled}
				className={`${ ns }__decrement`}
				aria-label={decrementLabel}
				onClick={onDecrement}
			>
				<span>-</span>
			</button>
			<input
				disabled={disabled}
				type="number"
				inputMode="numeric"
				min="1"
				step="1"
				className={[`${ ns }__input`, className].join(' ')}
				{...props}
			/>
			<button
				type="button"
				disabled={disabled}
				className={`${ ns }__increment`}
				aria-label={incrementLabel}
				onClick={onIncrement}
			>
				<span>+</span>
			</button>
		</div>
	);
};

export default NumericInput;
